<template>
	<span :title="titleDate">{{ formattedDate() }}</span>
</template>

<script>

import moment from 'moment';

/**
 * Date Component - For displaying friendly dates to the user
 */
export default {

    props: {
        date: {
            type: String,
            required: true,
        },
        /**
         * The timezone the provided date is in. Database dates are generally UTC
         */
        sourceTimezone: {
            type: String,
            default: 'UTC',
        }
    },

	data() {
		return {
			intRef: null,
			interval: 60,
		};
	},

	computed: {

		titleDate() {
			const momentDate = moment.utc(this.date);

			// TODO - This getTimezoneOffset isn't quite right it returns a positive integer even though for America/Los_Angeles it should be negative
			return momentDate.utcOffset(-1 * new Date().getTimezoneOffset()).format('lll');
		},

	},

	mounted() {
		this.startRenderCycle();
	},

	beforeDestroy() {
		this.killRenderCycle();
	},

	methods: {

		/**
		 * The relative formatted date
		 */
		formattedDate() {
			const momentDate = moment.utc(this.date);

			if (!momentDate.isValid()) {
				return '';
			}

			if (moment().subtract(14, 'day').isSameOrAfter(momentDate)) {
				return momentDate.format('MMM D, YYYY');
			}

			return momentDate.fromNow();
		},

		/**
		 * Return interval in SECONDS (not ms)
		 * @returns {number}
		 */
		getInterval() {
			const diff = Math.abs(moment().diff(moment.utc(this.date), 'minutes'), true);
			if (diff < 1) {
				return 2;
			}
			else if (diff < 15) {
				return 4;
			}
			else if (diff < 60) {
				return 60;
			}

			return 60 * 10;
		},

		/**
		 * Starts the cycle to force re-rendering this component
		 */
		startRenderCycle() {
			this.interval = this.getInterval();
			this.intRef = setInterval(() => {
				const checkInterval = this.getInterval();

				if (this.interval !== checkInterval) {
					// This post is older, don't need to force render so often
					clearInterval(this.intRef);
					this.startRenderCycle();
				}

				this.$forceUpdate();
			}, this.interval * 1000);
		},

		killRenderCycle() {
			// Unset Render Cycle
			clearInterval(this.intRef);
			this.intRef = null;
		},
	},
};
</script>



// WEBPACK FOOTER //
// resources/js/components/elements/RelativeDate.vue